<template>
    <div class="drivers-selection" v-show="hasMultiDrivers">
        <golia-button
            :variant="isDriverActive ? 'btn-fill dark-blue' : 'btn-fill gray'"
            class="ml-2"
            label="Autista 1"
            icon="fa fa-user"
            @click="onClick('driver')"
        />
        <golia-button
            :variant="isCodriverActive ? 'btn-fill dark-blue' : 'btn-fill gray'"
            label="Autista 2"
            icon="fa fa-user"
            @click="onClick('codriver')"
        />
    </div>
</template>

<script>
import { computed, ref, toRefs, watch } from 'vue'

export default {
    name: 'DriversSelector',
    props: {
        truckLastPoint: {
            type: Object,
            required: true
        },
        value: Object
    },
    setup(props, { emit }) {
        const { truckLastPoint, value: driver } = toRefs(props)

        const active = ref('driver')

        const truckDriver = computed(() => truckLastPoint.value?.driver)
        const truckCodriver = computed(() => truckLastPoint.value?.codriver)
        const hasMultiDrivers = computed(() => truckDriver.value && truckCodriver.value)
        const isDriverActive = computed(() => active.value === 'driver')
        const isCodriverActive = computed(() => active.value === 'codriver')

        const onClick = (tag) => {
            active.value = tag
            emit('change', {
                type: tag, //driver o codriver
                data: tag === 'driver' ? truckDriver.value : truckCodriver.value
            })
        }

        watch(
            driver,
            (newDriver) => {
                if (newDriver?.id === truckDriver.value?.id) active.value = 'driver'
                else active.value = 'codriver'
            },
            { immediate: true }
        )

        return {
            truckDriver,
            truckCodriver,
            hasMultiDrivers,
            active,
            isDriverActive,
            isCodriverActive,
            onClick
        }
    }
}
</script>

<style lang="scss">
.drivers-selection {
    display: flex;
    align-items: center;
    gap: 5px;
}

// Mobile: the panel header is narrow, so the selector can't always share a row
// with the title and close button. Size it to its chips and let it wrap to its
// own line (the header already wraps) rather than stretching across the panel.
.geofleet-mobile .drivers-selection {
    flex: 1 0 100%;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    // Hide the scrollbar strip; the overflow stays swipe/drag scrollable.
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }

    // Keep the chips narrow on the mobile panel (trim horizontal padding only,
    // leave the height/font alone).
    .btn {
        padding-left: 8px;
        padding-right: 8px;
    }
}
</style>
